import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Download } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const MyCarnets = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/me/carnets").then((r) => setItems(r.data || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="mt-12" data-testid="my-carnets">
      <h3 className="font-serif text-2xl text-[#1F2A24]">Mes carnets PDF</h3>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {items.map((c) => (
          <div key={c.id} className="rounded-xl bg-white border border-[#E8DCC4] p-4 flex items-center justify-between">
            <div>
              <p className="font-serif text-lg text-[#1F2A24]">{c.title || c.name}</p>
              {c.number != null && <p className="font-sans text-xs text-[#1F2A24]/50">Carnet {c.number}</p>}
            </div>
            {c.has_pdf ? (
              <a href={`${BACKEND}/api/carnets/${c.id}/download`} data-testid={`download-carnet-${c.id}`}
                className="inline-flex items-center gap-2 rounded-full bg-[#385E3A] text-white px-4 py-2.5 font-ui text-sm hover:bg-[#2c4a2e]">
                <Download size={15} /> Télécharger mon PDF
              </a>
            ) : <span className="font-sans text-xs text-[#1F2A24]/40">PDF à venir</span>}
          </div>
        ))}
      </div>
    </div>
  );
};
